import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { Layer, Source, useMap } from "react-map-gl";
import { useMapStore, useRecordedSaleStore } from "../..";
import useNavigateToProperty from "../../hooks/useNavigateToProperty";
import { minZoom } from "../mapConfig";

export const recordedSalesLayerId = "recordedSalesLayer";

function RecordedSalesMapLayer() {
    const map = useMap().current!;
    const navigateToProperty = useNavigateToProperty();
    const mapStore = useMapStore();
    const recordedSaleStore = useRecordedSaleStore();
    const recordedSalesGeoJson: any = useMemo(() => computed(() => ({
        type: "FeatureCollection",
        features: recordedSaleStore.recordedSales.length
            ? recordedSaleStore.recordedSales.map(rs => ({
                type: "Feature",
                id: `${rs.id}`,
                geometry: {
                    type: "Point",
                    coordinates: [rs.centerPoint.longitude, rs.centerPoint.latitude],
                },
                properties: {
                    latitude: rs.centerPoint.latitude,
                    longitude: rs.centerPoint.longitude,
                },
            })) : [],
    })), []).get();

    useEffect(() => {
        map.loadImage('./recorded-sale.png', (error, image) => {
            if (error) throw error;
            map.addImage('recorded-sale-marker', image!);
        });
    }, []);

    useEffect(() => {
        const unsubscribeMouseClick = mapStore.onMouseClick("recordedsales", feature => {
            if (feature?.layer?.id === recordedSalesLayerId)
                navigateToProperty(feature.properties!.longitude, feature.properties!.latitude);
        });

        return unsubscribeMouseClick;
    }, []);

    if (!recordedSaleStore.recordedSales.length)
        return null;

    return (
        <Source id="recordedSalesSource" type="geojson" data={recordedSalesGeoJson}>
            <Layer
                id={recordedSalesLayerId}
                type="symbol"
                minzoom={minZoom.recordedSales}
                layout={{
                    "icon-allow-overlap": true,
                    "symbol-z-order": "source",
                    "icon-image": "recorded-sale-marker",
                }}
            />
        </Source>
    );
}

export default observer(RecordedSalesMapLayer);